// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.program-name {
  font-size: 13px;              /* Base size for normal screens */
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.7);
  word-break: break-word;
  text-align: justify;
  margin-bottom: 4px;

  /* For better small-screen wrapping */
  overflow-wrap: anywhere;
}

/* Small screens (mobile) */
@media (max-width: 576px) {
  .program-name {
    font-size: 12px;
    line-height: 1.3;
    text-align: left;           /* Justified text can look cramped on phones */
  }
}

/* Medium screens (tablets) */
@media (min-width: 577px) and (max-width: 992px) {
  .program-name {
    font-size: 13px;
    line-height: 1.4;
  }
}

/* Large screens (desktop) */
@media (min-width: 993px) {
  .program-name {
    font-size: 14px;
    line-height: 1.5;
  }
}

.card-disabled {
  opacity: 0.60;
  pointer-events: none; 
  /* filter: grayscale(25%); */
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/pages/ZeroCoursePayments/technologyCards.css"],"names":[],"mappings":"AAAA;EACE,eAAe,eAAe,iCAAiC;EAC/D,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;;EAElB,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB,YAAY,8CAA8C;EAC5E;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,4BAA4B;EAC5B,2CAA2C;AAC7C","sourcesContent":[".program-name {\r\n  font-size: 13px;              /* Base size for normal screens */\r\n  line-height: 1.4;\r\n  color: rgba(255, 255, 255, 0.7);\r\n  word-break: break-word;\r\n  text-align: justify;\r\n  margin-bottom: 4px;\r\n\r\n  /* For better small-screen wrapping */\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n/* Small screens (mobile) */\r\n@media (max-width: 576px) {\r\n  .program-name {\r\n    font-size: 12px;\r\n    line-height: 1.3;\r\n    text-align: left;           /* Justified text can look cramped on phones */\r\n  }\r\n}\r\n\r\n/* Medium screens (tablets) */\r\n@media (min-width: 577px) and (max-width: 992px) {\r\n  .program-name {\r\n    font-size: 13px;\r\n    line-height: 1.4;\r\n  }\r\n}\r\n\r\n/* Large screens (desktop) */\r\n@media (min-width: 993px) {\r\n  .program-name {\r\n    font-size: 14px;\r\n    line-height: 1.5;\r\n  }\r\n}\r\n\r\n.card-disabled {\r\n  opacity: 0.60;\r\n  pointer-events: none; \r\n  /* filter: grayscale(25%); */\r\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
